var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia, util } from '@joint/plus';
var TYPE = 'yamazumi.RectPrism';
var RectPrism = /** @class */ (function (_super) {
    __extends(RectPrism, _super);
    function RectPrism(attributes, options) {
        attributes.labelColor = attributes.labelColor || '#000000';
        var topColor = attributes.topColor, sideColor = attributes.sideColor, frontColor = attributes.frontColor, depth = attributes.depth, label = attributes.label, labelColor = attributes.labelColor;
        return _super.call(this, util.defaultsDeep({
            attrs: {
                top: {
                    fill: topColor,
                    d: "M 0 0 l ".concat(depth, " -").concat(depth, " h calc(w) l -").concat(depth, " ").concat(depth, " z")
                },
                side: {
                    fill: sideColor,
                    d: "M calc(w) 0 l ".concat(depth, " -").concat(depth, " v calc(h-").concat(RectPrism.bottomMargin, ") l -").concat(depth, " ").concat(depth, " z")
                },
                front: {
                    fill: frontColor
                },
                label: {
                    text: label,
                    fill: labelColor
                }
            }
        }, attributes), options) || this;
    }
    RectPrism.prototype.preinitialize = function () {
        this.markup = util.svg /* xml */(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            <path @selector=\"top\"/>\n            <path @selector=\"side\"/>\n            <rect @selector=\"front\"/>\n            <text @selector=\"label\"/>\n        "], [/* xml */ "\n            <path @selector=\"top\"/>\n            <path @selector=\"side\"/>\n            <rect @selector=\"front\"/>\n            <text @selector=\"label\"/>\n        "])));
    };
    RectPrism.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: TYPE, size: {
                width: 180,
                height: 50
            }, attrs: {
                front: {
                    width: 'calc(w)',
                    height: "calc(h-".concat(RectPrism.bottomMargin, ")"),
                    strokeWidth: 0
                },
                side: {
                    strokeWidth: 0,
                },
                top: {
                    strokeWidth: 0,
                },
                label: {
                    class: 'jj-yamazumi-prism-text',
                    textVerticalAnchor: 'top',
                    y: 10,
                    x: 10,
                    textWrap: {
                        width: 'calc(w-70)',
                        height: 'calc(h-10)',
                        ellipsis: true
                    }
                },
            } });
    };
    RectPrism.bottomMargin = 2;
    return RectPrism;
}(dia.Element));
export { RectPrism };
var RectPrismView = /** @class */ (function (_super) {
    __extends(RectPrismView, _super);
    function RectPrismView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return RectPrismView;
}(dia.ElementView));
export { RectPrismView };
var templateObject_1;
